import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import { UserPlus } from '@phosphor-icons/react';
import { toast } from 'sonner';

const API = '/api';

const NovoLead = () => {
  const { user } = useAuth();
  const isBroker = user?.role === 'corretor';
  const [enterprises, setEnterprises] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    enterprise: '',
    source: 'Stand de Vendas',
    buyer_intent: '',
    assigned_to: '',
    notes: '',
  });

  useEffect(() => {
    axios.get(`${API}/enterprises`, { withCredentials: true })
      .then(({ data }) => setEnterprises(data))
      .catch(() => toast.error('Erro ao carregar empreendimentos'));

    if (!isBroker) {
      axios.get(`${API}/brokers`, { withCredentials: true })
        .then(({ data }) => setBrokers(data))
        .catch(() => toast.error('Erro ao carregar corretores'));
    }
  }, []);

  const update = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!form.name.trim() || !form.phone.trim()) {
      toast.error('Nome e telefone são obrigatórios');
      return;
    }

    setSaving(true);

    const notes = [
      form.buyer_intent ? `Busca por: ${form.buyer_intent}` : '',
      form.notes || ''
    ].filter(Boolean).join('\n\n');

    try {
      await axios.post(`${API}/leads`, {
        name: form.name,
        phone: form.phone,
        email: form.email || null,
        enterprise: form.enterprise || null,
        source: form.source,
        notes: notes || null,
        assigned_to: isBroker ? user?.id : (form.assigned_to || null),
        buyer_intent: form.buyer_intent || null,
      }, { withCredentials: true });

      toast.success('Lead cadastrado com sucesso');

      setForm({
        name: '',
        phone: '',
        email: '',
        enterprise: '',
        source: 'Stand de Vendas',
        buyer_intent: '',
    assigned_to: '',
        notes: '',
      });
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.detail || 'Erro ao cadastrar lead');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-xl bg-emerald-100 text-emerald-700">
            <UserPlus size={30} weight="duotone" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900">Novo Lead</h1>
            <p className="text-slate-600 mt-1">Cadastro rápido para recepção, feirão e stand de vendas</p>
          </div>
        </div>

        
          <div className="mt-5 bg-white rounded-xl border border-slate-200 shadow-sm p-5">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Portal de Captação</h2>
                <p className="text-sm text-slate-500 mt-1">
                  Use quando o próprio cliente preferir preencher o cadastro pelo celular através do Portal Público.
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                <a
                  href="/captura/dona-residencial"
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-lg bg-indigo-600 text-white font-semibold hover:bg-indigo-700"
                >
                  Abrir Portal
                </a>
              </div>

              <div className="flex flex-wrap gap-2">
              </div>
            </div>
          </div>

<form onSubmit={submit} className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label className="text-sm font-medium text-slate-700">Nome *</label>
              <input className="mt-1 w-full border rounded-lg px-3 py-3" value={form.name} onChange={(e) => update('name', e.target.value)} />
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700">Telefone *</label>
              <input className="mt-1 w-full border rounded-lg px-3 py-3" value={form.phone} onChange={(e) => update('phone', e.target.value)} placeholder="(87) 99999-9999" />
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700">Email</label>
              <input className="mt-1 w-full border rounded-lg px-3 py-3" value={form.email} onChange={(e) => update('email', e.target.value)} />
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700">Origem</label>
              <select className="mt-1 w-full border rounded-lg px-3 py-3" value={form.source} onChange={(e) => update('source', e.target.value)}>
                <option>Stand de Vendas</option>
                <option>Feirão</option>
                <option>WhatsApp</option>
                <option>Instagram</option>
                <option>Facebook Ads</option>
                <option>Google Ads</option>
                <option>Indicação</option>
                <option>Telefone</option>
                <option>Site</option>
                <option>Corretor</option>
                <option>Outro</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700">Empreendimento</label>
              <select className="mt-1 w-full border rounded-lg px-3 py-3" value={form.enterprise} onChange={(e) => update('enterprise', e.target.value)}>
                <option value="">Selecione</option>
                {enterprises.map((item) => (
                  <option key={item.id} value={item.name}>{item.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700">Busca por</label>
              <select className="mt-1 w-full border rounded-lg px-3 py-3" value={form.buyer_intent} onChange={(e) => update('buyer_intent', e.target.value)}>
                <option value="">Não informado</option>
                <option>Moradia própria</option>
                <option>Investimento</option>
                <option>Simulação de financiamento</option>
                <option>Conhecer empreendimento</option>
                <option>Ainda avaliando opções</option>
              </select>
            </div>

            <div className="md:col-span-2">
              <label className="text-sm font-medium text-slate-700">Corretor responsável</label>
              {isBroker ? (
                <div className="mt-1 w-full border rounded-lg px-3 py-3 bg-slate-50 text-slate-700">
                  {user?.name || 'Você'}
                  <p className="text-xs text-slate-500 mt-1">
                    Leads cadastrados por corretor ficam automaticamente na própria carteira.
                  </p>
                </div>
              ) : (
                <>
                  <select className="mt-1 w-full border rounded-lg px-3 py-3" value={form.assigned_to} onChange={(e) => update('assigned_to', e.target.value)}>
                    <option value="">IA assume imediatamente</option>
                    {brokers.map((broker) => (
                      <option key={broker.id} value={broker.id}>{broker.name}</option>
                    ))}
                  </select>
                  <p className="text-xs text-slate-500 mt-1">
                    Se escolher um corretor, ele será dono da conversa. A IA cobra atualização em 24h e reassume em 48h se não houver retorno.
                  </p>
                </>
              )}
            </div>

            <div className="md:col-span-2">
              <label className="text-sm font-medium text-slate-700">Observações</label>
              <textarea className="mt-1 w-full border rounded-lg px-3 py-3 min-h-[130px]" value={form.notes} onChange={(e) => update('notes', e.target.value)} placeholder="Ex.: Tem FGTS, quer simular financiamento, busca 2 quartos..." />
            </div>
          </div>

          <button disabled={saving} className="w-full md:w-auto px-8 py-3 rounded-lg bg-emerald-600 text-white font-semibold hover:bg-emerald-700 disabled:opacity-60">
            {saving ? 'Salvando...' : 'Cadastrar Lead'}
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default NovoLead;
